import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import ControlPanel from './ControlPanel';
import Lot from 'components/Lot';
import { useStores } from 'stores';
import styles from './styles.module.scss';

const LotPage = () => {
  const { lotStore, singleLotStore, userStore } = useStores();
  const { id } = useParams();
  const userProfileCurrency = userStore.currency;

  useEffect(() => {
    if (userProfileCurrency) {
      singleLotStore.getSingleLotAsync(id, userProfileCurrency);
    }
  }, [id, userProfileCurrency]);

  return (
    <main>
      <section className={styles.bns3_lot_page_control_panel_section}>
        <div className={styles.bns3_mainContainer}>
          <ControlPanel singleLotStore={singleLotStore} lotStore={lotStore} />
        </div>
      </section>

      <Lot />
    </main>
  );
};

LotPage.propTypes = {
  lotStore: PropTypes.shape({
    lotDataTotal: PropTypes.number,
    lotData: PropTypes.array,
    currentPage: PropTypes.number,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  singleLotStore: PropTypes.shape({
    getSingleLotAsync: PropTypes.func,
  }),
};

export default observer(LotPage);
